// Predefined facilities data
export interface FacilityOption {
  id: string;
  name: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
  contact: {
    phone: string;
    email: string;
  };
  type: 'Nursing Home' | 'Post Acute' | 'Healthcare Center' | 'Care Center' | 'Wellness Center';
}

export const PREDEFINED_FACILITIES: FacilityOption[] = [
  {
    id: 'american-river-care',
    name: 'American River Care Center',
    address: {
      street: '1234 American River Dr',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95825',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0101',
      email: 'info@americanrivercare.com'
    },
    type: 'Care Center'
  },
  {
    id: 'auburn-oaks-care',
    name: 'Auburn Oaks Care Center',
    address: {
      street: '5678 Auburn Oaks Way',
      city: 'Auburn',
      state: 'CA',
      zipCode: '95603',
      country: 'USA'
    },
    contact: {
      phone: '(530) 555-0102',
      email: 'info@auburnoaks.com'
    },
    type: 'Care Center'
  },
  {
    id: 'auburn-ravine-terrace',
    name: 'Auburn Ravine Terrace',
    address: {
      street: '9012 Ravine Terrace Ln',
      city: 'Auburn',
      state: 'CA',
      zipCode: '95603',
      country: 'USA'
    },
    contact: {
      phone: '(530) 555-0103',
      email: 'info@auburnravine.com'
    },
    type: 'Care Center'
  },
  {
    id: 'bruceville-terrace',
    name: 'Bruceville Terrace',
    address: {
      street: '3456 Bruceville Rd',
      city: 'Elk Grove',
      state: 'CA',
      zipCode: '95758',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0104',
      email: 'info@brucevilleterrace.com'
    },
    type: 'Care Center'
  },
  {
    id: 'citrus-heights-post-acute',
    name: 'Citrus Heights Post Acute',
    address: {
      street: '7890 Citrus Heights Blvd',
      city: 'Citrus Heights',
      state: 'CA',
      zipCode: '95610',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0105',
      email: 'info@citrusheightspostacute.com'
    },
    type: 'Post Acute'
  },
  {
    id: 'college-oak-nursing',
    name: 'College Oak Nursing',
    address: {
      street: '2345 College Oak Dr',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95841',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0106',
      email: 'info@collegeoaknursing.com'
    },
    type: 'Nursing Home'
  },
  {
    id: 'crystal-ridge-care',
    name: 'Crystal Ridge Care Center',
    address: {
      street: '6789 Crystal Ridge Way',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95828',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0107',
      email: 'info@crystalridgecare.com'
    },
    type: 'Care Center'
  },
  {
    id: 'falcon-wellbeing-care',
    name: 'Falcon Wellbeing Care',
    address: {
      street: '4567 Falcon Way',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95834',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0108',
      email: 'info@falconwellbeing.com'
    },
    type: 'Wellness Center'
  },
  {
    id: 'greenhaven-healthcare',
    name: 'GreenHaven Healthcare Center',
    address: {
      street: '8901 GreenHaven Blvd',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95831',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0109',
      email: 'info@greenhavenhealthcare.com'
    },
    type: 'Healthcare Center'
  },
  {
    id: 'gold-country-health',
    name: 'Gold Country Health Center',
    address: {
      street: '1234 Gold Country Dr',
      city: 'Placerville',
      state: 'CA',
      zipCode: '95667',
      country: 'USA'
    },
    contact: {
      phone: '(530) 555-0110',
      email: 'info@goldcountryhealth.com'
    },
    type: 'Healthcare Center'
  },
  {
    id: 'manzanita-healthcare',
    name: 'Manzanita Healthcare Center',
    address: {
      street: '5678 Manzanita Ave',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95819',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0111',
      email: 'info@manzanitahealthcare.com'
    },
    type: 'Healthcare Center'
  },
  {
    id: 'marysville-post-acute',
    name: 'Marysville Post Acute',
    address: {
      street: '9012 Marysville Blvd',
      city: 'Marysville',
      state: 'CA',
      zipCode: '95901',
      country: 'USA'
    },
    contact: {
      phone: '(530) 555-0112',
      email: 'info@marysvillepostacute.com'
    },
    type: 'Post Acute'
  },
  {
    id: 'mckinley-park-care',
    name: 'McKinley Park Care Center',
    address: {
      street: '3456 McKinley Park Dr',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95816',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0113',
      email: 'info@mckinleyparkcare.com'
    },
    type: 'Care Center'
  },
  {
    id: 'midtown-oaks-post-acute',
    name: 'Midtown Oaks Post Acute',
    address: {
      street: '7890 Midtown Oaks Way',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95814',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0114',
      email: 'info@midtownoakspostacute.com'
    },
    type: 'Post Acute'
  },
  {
    id: 'pine-creek-care',
    name: 'Pine Creek Care Center',
    address: {
      street: '2345 Pine Creek Dr',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95825',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0115',
      email: 'info@pinecreekcare.com'
    },
    type: 'Care Center'
  },
  {
    id: 'river-valley-care',
    name: 'River Valley Care Center',
    address: {
      street: '6789 River Valley Way',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95822',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0116',
      email: 'info@rivervalleycare.com'
    },
    type: 'Care Center'
  },
  {
    id: 'pioneer-house',
    name: 'Pioneer House',
    address: {
      street: '4567 Pioneer House Ln',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95817',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0117',
      email: 'info@pioneerhouse.com'
    },
    type: 'Care Center'
  },
  {
    id: 'roseville-care',
    name: 'Roseville Care Center',
    address: {
      street: '8901 Roseville Blvd',
      city: 'Roseville',
      state: 'CA',
      zipCode: '95661',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0118',
      email: 'info@rosevillecare.com'
    },
    type: 'Care Center'
  },
  {
    id: 'roseville-point-health',
    name: 'Roseville Point Health and Wellness',
    address: {
      street: '1234 Roseville Point Dr',
      city: 'Roseville',
      state: 'CA',
      zipCode: '95678',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0119',
      email: 'info@rosevillepointhealth.com'
    },
    type: 'Wellness Center'
  },
  {
    id: 'sacramento-post-acute',
    name: 'Sacramento Post Acute',
    address: {
      street: '5678 Sacramento Blvd',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95815',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0120',
      email: 'info@sacramentopostacute.com'
    },
    type: 'Post Acute'
  },
  {
    id: 'the-grove-post-acute',
    name: 'The Grove Post Acute',
    address: {
      street: '9012 Grove Way',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95820',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0121',
      email: 'info@thegrovepostacute.com'
    },
    type: 'Post Acute'
  },
  {
    id: 'the-pines-placerville',
    name: 'The Pines at Placerville Healthcare Center',
    address: {
      street: '3456 Pines Dr',
      city: 'Placerville',
      state: 'CA',
      zipCode: '95667',
      country: 'USA'
    },
    contact: {
      phone: '(530) 555-0122',
      email: 'info@thepinesplacerville.com'
    },
    type: 'Healthcare Center'
  },
  {
    id: 'western-slope-health',
    name: 'Western Slope Health Center',
    address: {
      street: '7890 Western Slope Way',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95823',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0123',
      email: 'info@westernslopehealth.com'
    },
    type: 'Healthcare Center'
  },
  {
    id: 'westview-healthcare',
    name: 'Westview Healthcare Center',
    address: {
      street: '2345 Westview Dr',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95824',
      country: 'USA'
    },
    contact: {
      phone: '(916) 555-0124',
      email: 'info@westviewhealthcare.com'
    },
    type: 'Healthcare Center'
  },
  {
    id: 'yuba-city-post-acute',
    name: 'Yuba City Post Acute',
    address: {
      street: '6789 Yuba City Blvd',
      city: 'Yuba City',
      state: 'CA',
      zipCode: '95991',
      country: 'USA'
    },
    contact: {
      phone: '(530) 555-0125',
      email: 'info@yubacitypostacute.com'
    },
    type: 'Post Acute'
  }
];

// Helper function to get facility by name
export const getFacilityByName = (name: string): FacilityOption | undefined => {
  return PREDEFINED_FACILITIES.find(facility => 
    facility.name.toLowerCase() === name.toLowerCase()
  );
};

// Helper function to get facilities by type
export const getFacilitiesByType = (type: string): FacilityOption[] => {
  return PREDEFINED_FACILITIES.filter(facility => facility.type === type);
};

// Helper function to search facilities
export const searchFacilities = (query: string): FacilityOption[] => {
  const lowercaseQuery = query.toLowerCase();
  return PREDEFINED_FACILITIES.filter(facility => 
    facility.name.toLowerCase().includes(lowercaseQuery) ||
    facility.address.city.toLowerCase().includes(lowercaseQuery) ||
    facility.address.state.toLowerCase().includes(lowercaseQuery)
  );
};
